import { ComponentProps, MouseEvent } from 'react';
import { useIntl } from 'react-intl';

export function SearchInput({
  onClick,
  ...props
}: Omit<ComponentProps<'input'>, 'onClick'> & { onClick?: () => void }) {
  const { formatMessage } = useIntl();

  const handleClick = (event: MouseEvent<HTMLInputElement>) => {
    event.stopPropagation();
    onClick?.();
  };

  return (
    <div className="product-search-input-container input-group input-group-xl" id="search-product">
      <div className="input-icon-start">
        <em className="icon-outlined icon" aria-hidden="true">
          category
        </em>
      </div>
      <input
        {...props}
        type="search"
        name="product-selector-search-input"
        className="form-control form-control-xl"
        placeholder={formatMessage({ id: 'essential.workspace.search.input.placeholder' })}
        autoComplete="off"
        aria-label="Search products"
        onClick={handleClick}
      />
    </div>
  );
}
